export default __webpack_public_path__ + "static/media/stake.554581b1.jpg";